import React from 'react';
import { StyleSheet } from 'react-native';
import { DNAText } from '@alucio/lux-ui';
import { useContent } from 'src/state/context/ContentProvider/ContentProvider';
import { tabConfigs } from 'src/components/ContentPreviewModalV2/SideBar';
import SidebarContent from 'src/components/ContentPreviewModalV2/SideBar/SideBarContent';

const styles = StyleSheet.create({
  sidebarContentText: {
    maxWidth: 280,
  },
})

const SpeakerNotes: React.FC = () => {
  const { activePresentation, contentPageData } = useContent();
  const speakerNotes = activePresentation?.currentPresentablePage
    ? contentPageData[activePresentation?.currentPresentablePage.presentationPageNumber - 1]?.speakerNotes : undefined;
  return (
    <SidebarContent>
      <SidebarContent.Header
        sidebarHeader={tabConfigs.speakerNotes.label}
      />
      <SidebarContent.Body>
        <DNAText style={styles.sidebarContentText}>
          {speakerNotes ?? 'No slide notes'}
        </DNAText>
      </SidebarContent.Body>
    </SidebarContent>
  )
}

export default SpeakerNotes;
